// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IeOutlinedSvg from "@fishx/icons-svg/es/asn/IeOutlined";
import FishxIcon from '../components/FishxIcon';

var IeOutlined = function IeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IeOutlinedSvg
  }));
};

IeOutlined.displayName = 'IeOutlined';
export default React.forwardRef(IeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IeOutlined.js
// module id = 2955
// module chunks = 0